<template lang="pug">
  .two-col.container(:class="[spacingTop, spacingBottom]" v-if="contents && contents.length" ref="container")
    .content-wrap.rte-area
      div(v-if="content1 && content1.text" v-html="content1.text")
      div(v-if="content2 && content2.text" v-html="content2.text")
</template>

<script>
export default {
    name: 'Post2Cols',
    data() {
        return {
            containerWidth: undefined
        };
    },
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    filters: {
        replace: function(st, rep, repWith) {
            const result = st.split(rep).join(repWith);
            return result;
        }
    },
    computed: {
        contents() {
            return this.section.contents || [];
        },
        content1() {
            return this.contents.find(content => content.key === 'content-1');
        },

        content2() {
            return this.contents.find(content => content.key === 'content-2');
        },
        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },
        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        }
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.two-col
  @apply mx-auto

  .content-wrap
    @apply grid grid-cols-1 gap-8
    @screen md
      @apply grid-cols-2 gap-16
</style>
